// src/apps/frontend/routes/index.tsx
import {Routes, Route, Navigate} from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import Dashboard from "~/apps/cartario/pages/Dashboard.tsx";
import Billing from "~/components/Billing.tsx";
import {BillingGuard} from "~/apps/auth/utils/BillingUtils.tsx";
import ProductImages from "~/apps/cartario/pages/ProductImages.tsx";
import ThemeImages from "~/apps/cartario/pages/ThemeImages.tsx";
import ImageEdit from "~/apps/cartario/pages/ImageEdit.tsx";
import ImageReplace from "~/apps/cartario/pages/ImageReplace.tsx";
import MyImages from "~/apps/cartario/pages/MyImages.tsx";
import MyModels from "~/apps/cartario/pages/MyModels.tsx";
import GenerateImages from "~/apps/cartario/pages/GenerateImages.tsx";
import GenerateModelImage from "~/apps/cartario/pages/GenerateModelImage.tsx";
import Generate from "~/apps/cartario/pages/Generate.tsx";

export const BaseRoutes = () => {
    const routes = [
        {
            path: '/',
            component: <Dashboard />,
            requiresBilling: true
        },
        {
            path: '/dashboard',
            component: <Dashboard />,
            requiresBilling: true
        },
        {
            path: '/generate-images',
            component: <GenerateImages />,
            requiresBilling: true
        },
        {
            path: '/generate-images/:public_id',
            component: <GenerateModelImage />,
            requiresBilling: true
        },
        {
            path: '/generate/:public_id/:category',
            component: <Generate />,
            requiresBilling: true
        },
        {
            path: '/galleries',
            component: <MyImages />,
            requiresBilling: true
        },
        {
            path: '/models',
            component: <MyModels />,
            requiresBilling: true
        },
        {
            path: '/products/images',
            component: <ProductImages />,
            requiresBilling: true
        },
        {
            path: '/theme/images',
            component: <ThemeImages />,
            requiresBilling: true
        },
        {
            path: '/image/edit/:id',
            component: <ImageEdit />,
            requiresBilling: true
        },
        {
          path: '/image/:type/replace/:id',
            component: <ImageReplace />,
            requiresBilling: true
        },
        {
            path: '/billing',
            component: <Billing />,
            requiresBilling: false,
        }
    ]
    return (
        <MainLayout>
            <Routes>
                {routes.map((route, index) => (
                    route.requiresBilling ? (
                        <Route
                            key={index}
                            path={route.path}
                            element={<BillingGuard>{route.component}</BillingGuard>}
                        />
                    ) : (
                        <Route
                            key={index}
                            path={route.path}
                            element={route.component}
                        />
                    )
                ))}
                <Route path="/*" element={<Navigate to="/errors/404" replace />} />
            </Routes>
        </MainLayout>
    );
}
